import React from "react";
import { Button } from "react-materialize";
import Func from "utils/Func";
import { useNotify } from "context/NotifyContext";

export default function BtnClear() {
  const { defaultFilters, storeFilters } = useNotify();

  let handleEvents = {
    OnClick: function (evt) {
      evt.preventDefault();
      storeFilters({
        ...defaultFilters,
        keyChange: Func.GetKeyRandom(),
      });
    },
  };

  return (
    <Button
      node="button"
      type="button"
      className="blue-grey lighten-5"
      id="btn-clear"
      style={{ float: "right", marginLeft: "15px", color: "#000" }}
      onClick={handleEvents.OnClick}
    >
      Clear All
    </Button>
  );
}
